<template>
  <div>
    <ComplexExcel :label="label" @save="onClickSave" @customAlert="customAlert" />
  </div>
</template>

<script>
import ComplexExcel from "@/views/fields/template/ComplexExcel.vue";

export default {
  props:{
    label: String
  },
  components: { ComplexExcel },
  methods: {
    onClickSave(option) {
      this.$emit("save", option);
    },
    customAlert(msg) {
      this.$emit("customAlert", msg);
    },
  },
};
</script>

<style scoped></style>
